module.exports = __webpack_public_path__ + "img/none.47a29c5b.svg";